// extracted by mini-css-extract-plugin
export default {"image-preview":"ProductForm_image-preview__fB33c"};